import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import List from '../views/List.vue'
import Enterprise from '../views/Enterprise.vue'
import Product from '../views/Product.vue'
import News from '../views/News.vue'
import NewsCategory from '../views/NewsCategory.vue'
import Case from '../views/Case.vue'
import CaseCategory from '../views/CaseCategory.vue'
import Solution from '../views/Solution.vue'
import Banner from '../views/Banner.vue'
import ProductCategory from '../views/ProductCategory.vue'



const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/list',
    name: 'List',
    component: List,
    redirect: '/list/enterprise',
    children: [
      {
        path: 'enterprise',
        name: 'Enterprise',
        component: Enterprise
      },
      {
        path: 'productcategory',
        name: 'ProductCategory',
        component: ProductCategory
      },
      {
        path: 'product',
        name: 'Product',
        component: Product
      },
      {
        path: 'news',
        name: 'News',
        component: News
      },
      {
        path: 'newscategory',
        name: 'NewsCategory',
        component: NewsCategory
      },
      {
        path: 'casecategory',
        name: 'CaseCategory',
        component: CaseCategory
      },
      {
        path: 'case',
        name: 'Case',
        component: Case
      },
      {
        path: 'solution',
        name: 'Solution',
        component: Solution
      },
      {
        path: 'banner',
        name: 'Banner',
        component: Banner
      }
    ]
  }
]

const router = createRouter({
  // 与 vue.config.js 的 publicPath 一致（构建时由 Vue CLI 注入 BASE_URL）
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
